import React from 'react';
import ReactDOM from 'react-dom';
import ContactsList from './components/ContactsList';
import connectToSocketServer from './connectToSocketServer';

export default function showContacts() {
  ReactDOM.unmountComponentAtNode(document.getElementById('root'));
  const socket = connectToSocketServer();
  ReactDOM.render(<ContactsList socket={socket} />, document.getElementById('root'));
}



// WEBPACK FOOTER //
// ./src/showContacts.js